/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ChangePasswordRequest,
  ForgotPasswordRequest,
  LoginRequest,
  ResetPasswordWithOtpRequest,
  TwoFactorVerifyRequest,
  UserProfile,
  UserProfileRequest,
  UsersForgotPasswordCreate200,
  UsersLoginCreate200,
  UsersLogoutCreate200,
  UsersResetPasswordCreate200
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Send a password reset code (OTP) to the user's email. Use the code in `resetPassword` endpoint to set a new password.
 * @summary Forgot password (request OTP)
 */
export const usersForgotPasswordCreate = (
    forgotPasswordRequest: ForgotPasswordRequest,
 ) => {
      
      
      return customInstance<UsersForgotPasswordCreate200>(
      {url: `/api/v1/users/forgotPassword/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forgotPasswordRequest
    },
      );
    }
  


export const getUsersForgotPasswordCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersForgotPasswordCreate>>, TError,{data: ForgotPasswordRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersForgotPasswordCreate>>, TError,{data: ForgotPasswordRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersForgotPasswordCreate>>, {data: ForgotPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  usersForgotPasswordCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersForgotPasswordCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersForgotPasswordCreate>>>
    export type UsersForgotPasswordCreateMutationBody = ForgotPasswordRequest
    export type UsersForgotPasswordCreateMutationError = unknown

    /**
 * @summary Forgot password (request OTP)
 */
export const useUsersForgotPasswordCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersForgotPasswordCreate>>, TError,{data: ForgotPasswordRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof usersForgotPasswordCreate>>,
        TError,
        {data: ForgotPasswordRequest},
        TContext
      > => {

      const mutationOptions = getUsersForgotPasswordCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 
        Authenticate user with email and password.
        On success, the server sets an auth cookie for subsequent requests.
        
 * @summary Login with email and password
 */
export const usersLoginCreate = (
    loginRequest: LoginRequest,
 ) => {
      
      
      return customInstance<UsersLoginCreate200>(
      {url: `/api/v1/users/login/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequest
    },
      );
    }
  


export const getUsersLoginCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersLoginCreate>>, TError,{data: LoginRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersLoginCreate>>, TError,{data: LoginRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersLoginCreate>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  usersLoginCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersLoginCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersLoginCreate>>>
    export type UsersLoginCreateMutationBody = LoginRequest
    export type UsersLoginCreateMutationError = void

    /**
 * @summary Login with email and password
 */
export const useUsersLoginCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersLoginCreate>>, TError,{data: LoginRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof usersLoginCreate>>,
        TError,
        {data: LoginRequest},
        TContext
      > => {

      const mutationOptions = getUsersLoginCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Logout current user and end the cookie session server-side.
 * @summary Logout user
 */
export const usersLogoutCreate = (
    
 ) => {
      
      
      return customInstance<UsersLogoutCreate200>(
      {url: `/api/v1/users/logout/`, method: 'POST'
    },
      );
    }
  


export const getUsersLogoutCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersLogoutCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersLogoutCreate>>, TError,void, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersLogoutCreate>>, void> = () => {
          

          return  usersLogoutCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersLogoutCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersLogoutCreate>>>
    
    export type UsersLogoutCreateMutationError = unknown

    /**
 * @summary Logout user
 */
export const useUsersLogoutCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersLogoutCreate>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof usersLogoutCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getUsersLogoutCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get current user profile information
 * @summary Get user profile
 */
export const usersProfileRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserProfile>(
      {url: `/api/v1/users/profile/`, method: 'GET', signal
    },
      );
    }
  

export const getUsersProfileRetrieveQueryKey = () => {
    return [`/api/v1/users/profile/`] as const;
    }

    
export const getUsersProfileRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof usersProfileRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersProfileRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersProfileRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersProfileRetrieve>>> = ({ signal }) => usersProfileRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersProfileRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type UsersProfileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersProfileRetrieve>>>
export type UsersProfileRetrieveQueryError = unknown

/**
 * @summary Get user profile
 */
export const useUsersProfileRetrieve = <TData = Awaited<ReturnType<typeof usersProfileRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersProfileRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUsersProfileRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Change the authenticated user's password. Requires the current password to confirm the session belongs to the account owner. On success, the current session is preserved and every other session of this user (cookie or header) is revoked.
 * @summary Change password
 */
export const usersProfileChangePasswordCreate = (
    changePasswordRequest: ChangePasswordRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/users/profile/changePassword/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changePasswordRequest
    },
      );
    }
  


export const getUsersProfileChangePasswordCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersProfileChangePasswordCreate>>, TError,{data: ChangePasswordRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersProfileChangePasswordCreate>>, TError,{data: ChangePasswordRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersProfileChangePasswordCreate>>, {data: ChangePasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  usersProfileChangePasswordCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersProfileChangePasswordCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersProfileChangePasswordCreate>>>
    export type UsersProfileChangePasswordCreateMutationBody = ChangePasswordRequest
    export type UsersProfileChangePasswordCreateMutationError = void

    /**
 * @summary Change password
 */
export const useUsersProfileChangePasswordCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersProfileChangePasswordCreate>>, TError,{data: ChangePasswordRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof usersProfileChangePasswordCreate>>,
        TError,
        {data: ChangePasswordRequest},
        TContext
      > => {

      const mutationOptions = getUsersProfileChangePasswordCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Reset password using email + OTP code that was sent via `forgotPassword`.
 * @summary Reset password with OTP
 */
export const usersResetPasswordCreate = (
    resetPasswordWithOtpRequest: ResetPasswordWithOtpRequest,
 ) => {
      
      
      return customInstance<UsersResetPasswordCreate200>(
      {url: `/api/v1/users/resetPassword/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordWithOtpRequest
    },
      );
    }
  


export const getUsersResetPasswordCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersResetPasswordCreate>>, TError,{data: ResetPasswordWithOtpRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersResetPasswordCreate>>, TError,{data: ResetPasswordWithOtpRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersResetPasswordCreate>>, {data: ResetPasswordWithOtpRequest}> = (props) => {
          const {data} = props ?? {};

          return  usersResetPasswordCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersResetPasswordCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersResetPasswordCreate>>>
    export type UsersResetPasswordCreateMutationBody = ResetPasswordWithOtpRequest
    export type UsersResetPasswordCreateMutationError = void

    /**
 * @summary Reset password with OTP
 */
export const useUsersResetPasswordCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersResetPasswordCreate>>, TError,{data: ResetPasswordWithOtpRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof usersResetPasswordCreate>>,
        TError,
        {data: ResetPasswordWithOtpRequest},
        TContext
      > => {

      const mutationOptions = getUsersResetPasswordCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Update current user profile information. Avatar can be uploaded with profile update.
 * @summary Update user profile
 */
export const usersUpdateProfileUpdate = (
    userProfileRequest: UserProfileRequest,
 ) => {
      
      
      return customInstance<UserProfile>(
      {url: `/api/v1/users/updateProfile/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userProfileRequest
    },
      );
    }
  


export const getUsersUpdateProfileUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUpdateProfileUpdate>>, TError,{data: UserProfileRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersUpdateProfileUpdate>>, TError,{data: UserProfileRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersUpdateProfileUpdate>>, {data: UserProfileRequest}> = (props) => {
          const {data} = props ?? {};

          return  usersUpdateProfileUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersUpdateProfileUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersUpdateProfileUpdate>>>
    export type UsersUpdateProfileUpdateMutationBody = UserProfileRequest
    export type UsersUpdateProfileUpdateMutationError = unknown

    /**
 * @summary Update user profile
 */
export const useUsersUpdateProfileUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUpdateProfileUpdate>>, TError,{data: UserProfileRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof usersUpdateProfileUpdate>>,
        TError,
        {data: UserProfileRequest},
        TContext
      > => {

      const mutationOptions = getUsersUpdateProfileUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Second leg of login when 2FA is enabled. Submit the `challengeToken` from `/login` together with either a TOTP code or a one-time recovery code. On success the session is created and the profile is returned in the same shape as `/login` for non-2FA accounts.
 * @summary Verify second factor and finish login
 */
export const usersVerifyTwoFactorCreate = (
    twoFactorVerifyRequest: TwoFactorVerifyRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/users/verifyTwoFactor/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: twoFactorVerifyRequest
    },
      );
    }
  


export const getUsersVerifyTwoFactorCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersVerifyTwoFactorCreate>>, TError,{data: TwoFactorVerifyRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersVerifyTwoFactorCreate>>, TError,{data: TwoFactorVerifyRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersVerifyTwoFactorCreate>>, {data: TwoFactorVerifyRequest}> = (props) => {
          const {data} = props ?? {};

          return  usersVerifyTwoFactorCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersVerifyTwoFactorCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersVerifyTwoFactorCreate>>>
    export type UsersVerifyTwoFactorCreateMutationBody = TwoFactorVerifyRequest
    export type UsersVerifyTwoFactorCreateMutationError = void

    /**
 * @summary Verify second factor and finish login
 */
export const useUsersVerifyTwoFactorCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersVerifyTwoFactorCreate>>, TError,{data: TwoFactorVerifyRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof usersVerifyTwoFactorCreate>>,
        TError,
        {data: TwoFactorVerifyRequest},
        TContext
      > => {

      const mutationOptions = getUsersVerifyTwoFactorCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    